var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.isLink ? "a" : "button",
    _vm._b(
      {
        tag: "component",
        staticClass:
          "relative flex items-center rounded px-2 group h-10 text-sm overflow-hidden desktop:h-8",
        attrs: { title: _vm.action },
        on: {
          click: function($event) {
            return _vm.$emit("click")
          }
        }
      },
      "component",
      _vm.isLink ? { target: "_blank", href: _vm.url } : { type: "button" },
      false
    ),
    [
      _c("div", { staticClass: "absolute bg-black-overlay inset-0" }),
      _c("BaseIcon", { staticClass: "w-4 h-4", attrs: { name: _vm.icon } }),
      _c(
        "div",
        {
          staticClass:
            "\n            text-left w-40 truncate duration-300 transition-all\n            group-hover:w-40 desktop:w-0\n        "
        },
        [_c("span", { staticClass: "ml-2" }, [_vm._v(_vm._s(_vm.actionText))])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }